import { createReducer, on } from '@ngrx/store';
import {
  createCurrentConsultation,
  createCurrentConsultationFail,
  createCurrentConsultationSuccess,
  createCurrentConsultationFromShareRecoPopin,
  placeVetSourceOrderError,
  placeVetSourceOrderSuccess,
  resetConsultationData,
  resetExpectedNextVisit,
  setConsultationLastConsultation,
  setConsultationPatient,
  setConsultationPetOwner,
  setConsultationRenalDetectRecommendation,
  setConsultationSetSkipProductBook,
  setCreatingCurrentConsultation,
  setCurrentConsultationVisitDate,
  setExpectedNextVisit,
  setIsWLPIncluded,
  setIsWLPEligible,
} from './consultation.actions';
import { initialConsultationState } from './consultation.state';

/**
 * Reducer for all data shared between tools during a consultation
 */
export const consultationReducer = createReducer(
  initialConsultationState,
  on(setCurrentConsultationVisitDate, (state, action) => ({
    ...state,
    currentConsultationVisitDate: action.value,
  })),
  on(setConsultationPatient, (state, action) => ({
    ...state,
    patient: action.value,
  })),
  on(setConsultationRenalDetectRecommendation, (state, action) => ({
    ...state,
    renalDetectRecommendation: action.value,
  })),
  on(setConsultationLastConsultation, (state, action) => ({
    ...state,
    lastConsultation: action.value,
  })),
  on(setConsultationSetSkipProductBook, (state, action) => ({
    ...state,
    skipProductBook: action.value,
  })),
  on(resetConsultationData, () => initialConsultationState),
  on(createCurrentConsultation, (state) => ({
    ...state,
    creatingCurrentConsultation: true,
  })),
  on(createCurrentConsultationFromShareRecoPopin, (state) => ({
    ...state,
    creatingCurrentConsultation: true,
  })),
  on(createCurrentConsultationSuccess, (state, action) => ({
    ...state,
    currentConsultation: action.consultation,
    creatingCurrentConsultation: false,
  })),
  on(createCurrentConsultationFail, (state) => ({
    ...state,
    creatingCurrentConsultation: false,
  })),
  on(setCreatingCurrentConsultation, (state, action) => ({
    ...state,
    creatingCurrentConsultation: action.value,
  })),
  on(setConsultationPetOwner, (state, action) => ({
    ...state,
    petOwner: action.value,
  })),
  on(setExpectedNextVisit, (state, action) => ({
    ...state,
    expectedNextVisit: action.value,
  })),
  on(resetExpectedNextVisit, (state) => ({
    ...state,
    expectedNextVisit: null,
  })),
  on(placeVetSourceOrderSuccess, (state) => ({ ...state, vetSourceOrderStatus: 'SUCCESS' as const })),
  on(placeVetSourceOrderError, (state) => ({ ...state, vetSourceOrderStatus: 'ERROR' as const })),
  on(setIsWLPEligible, (state, action) => ({ ...state, isWLPEligible: action.value })),
  on(setIsWLPIncluded, (state, action) => ({ ...state, isWLPIncluded: action.value })),
);
